import { InjectionToken, ValueProvider } from '@angular/core';

export const PRICE_API_ORIGIN = new InjectionToken<string>('Price API Origin');
export const providePriceApiOrigin = (origin: string): ValueProvider => ({
  provide: PRICE_API_ORIGIN,
  useValue: origin,
});
